import React from "react";
import { useMongoDBDataAdapterStats } from "../hooks/useMongoDBDataAdapter";
const MongoDBDataAdapterSummary = ({ dataAdapter }) => {
  var _a;
  const { data: statsData } = useMongoDBDataAdapterStats(dataAdapter.id);
  return /* @__PURE__ */ React.createElement("dl", null, /* @__PURE__ */ React.createElement("dt", null, "Database Entries"), /* @__PURE__ */ React.createElement("dd", null, (_a = statsData == null ? void 0 : statsData.entriesCount) != null ? _a : 0), /* @__PURE__ */ React.createElement("dt", null, "CIDR lookup"), /* @__PURE__ */ React.createElement("dd", null, dataAdapter.config.cidr_lookup ? "yes" : "no"));
};
export default MongoDBDataAdapterSummary;
